import { render, staticRenderFns } from "./order_customers.vue?vue&type=template&id=3fddf4be&scoped=true&"
import script from "./order_customers.vue?vue&type=script&lang=js&"
export * from "./order_customers.vue?vue&type=script&lang=js&"
import style0 from "./order_customers.vue?vue&type=style&index=0&id=3fddf4be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fddf4be",
  null
  
)

export default component.exports